import React, { useEffect, useState } from "react";
import Loader from "../components/Loader";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css"; // Import react-tabs styles
import "./Detail.css"; // Custom styles
import "react-tabs/style/react-tabs.css"; // Import react-tabs styles
import axios from "axios";
import { initializeApp } from "firebase/app";
import { getDatabase, ref, set } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBAnLqyTKiBZgBf-2bn5j-DFtBHt0I0mkE",
  authDomain: "opxcint.firebaseapp.com",
  databaseURL: "https://opxcint-default-rtdb.firebaseio.com",
  projectId: "opxcint",
  storageBucket: "opxcint.firebasestorage.app",
  messagingSenderId: "978767501597",
  appId: "1:978767501597:web:3d71595c627dbde51a29f4",
  measurementId: "G-K72PXXRS3W"
};

const Detail = () => {
  const app = initializeApp(firebaseConfig);
  const db = getDatabase(app);
  const [surveyID, setSurveyID] = useState(null);
  const [loading, setLoading] = useState(false);
  const [questionData, setQuestionData] = useState([]);
  const [QuotaQuestionData, setQuotaQuestionData] = useState([]);
  const [links, setLinks] = useState({});
  const [countryData, setCountryData] = useState({});
  const [details, setDetails] = useState(
    JSON.parse(sessionStorage.getItem("userData"))
  );

  useEffect(() => {
    const data = localStorage.getItem("userData");
    if (data) {
      let finalData = JSON.parse(data);
      setSurveyID(finalData?.survey_id);
      setDetails(finalData);
    }
  }, []);

  useEffect(() => {
    console.log("details ==> ", details);
    const fetchCountryCode = async () => {
      const url =
        "https://api.samplicio.us/Lookup/v1/BasicLookups/BundledLookups/CountryLanguages";

      const headers = {
        "Content-Type": "application/json",
        Authorization: "588917A2-1A5C-4D56-A823-B2E996515DE3",
      };

      try {
        const response = await axios.get(url, { headers });
        const originalString = details?.country_language;
        if (originalString) {
          const convertedCountry = originalString
            .split("_")
            .map((part) => part.toUpperCase())
            .join("-");
          let AllCountryLanguages = response?.data?.AllCountryLanguages;
          let currentCountry = AllCountryLanguages?.filter(
            (option) => option.Code === convertedCountry
          );
          setCountryData(currentCountry[0]);
        }
      } catch (error) {
        console.error(
          "Error:",
          error.response ? error.response.data : error.message
        );
      }
    };
    fetchCountryCode();
  }, [details?.country_language]);

  useEffect(() => {
    const handleCreateLink = async () => {
      if (!details?.survey_id) return;
      const url =
        "https://api.samplicio.us/Supply/v1/SupplierLinks/Create/" +
        details?.survey_id +
        "/6584";

      const data = {
        SupplierLinkTypeCode: "OWS",
        TrackingTypeCode: "NONE",
      };

      const headers = {
        "Content-Type": "application/json",
        Authorization: "588917A2-1A5C-4D56-A823-B2E996515DE3",
      };

      try {
        const response = await axios.post(url, data, { headers });
        setLinks(response.data);
      } catch (error) {
        const url =
          "https://api.samplicio.us/Supply/v1/SupplierLinks/BySurveyNumber/" +
          details?.survey_id +
          "/6584";

        const headers = {
          "Content-Type": "application/json",
          Authorization: "588917A2-1A5C-4D56-A823-B2E996515DE3",
        };

        try {
          const response = await axios.get(url, { headers });
          setLinks(response.data);
        } catch (error) {
          console.error(
            "Error:",
            error.response ? error.response.data : error.message
          );
        }
      }
    };
    handleCreateLink();
  }, [details?.survey_id]);

  //Fetch Qualification Question
  useEffect(() => {
    const fetchData = async () => {
      if (details?.survey_qualifications) {
        const allData = await Promise.all(
          details?.survey_qualifications.map((q) =>
            fetchQuestionData(q?.question_id, q)
          )
        );
        setQuestionData(allData.filter((data) => data !== null));
      }
    };
    fetchData();
  }, [details?.survey_qualifications, countryData]);

  //Fetch Quota Question
  useEffect(() => {
    if (details?.survey_quotas) {
      const fetchQuotaData = async () => {
        const allData = await Promise.all(
          details?.survey_quotas?.map((value) => {
            if (value?.questions) {
              return Promise.all(
                value.questions.map((option) =>
                  fetchQuotaQuestionData(option, value)
                )
              );
            }
            return Promise.resolve([]); // Return an empty array if there are no questions
          })
        );
        const filteredData = allData.filter((arr) => arr.length > 0);
        setQuotaQuestionData(filteredData);
      };
      fetchQuotaData();
    }
  }, [details?.survey_quotas, countryData]);

  const fetchQuotaQuestionData = async (questionData, value) => {
    let questionId = questionData?.question_id;
    let countryID = countryData?.Id;
    if (!countryID) {
      return;
    }
    const questionTextUrl =
      "https://api.samplicio.us/Lookup/v1/QuestionLibrary/QuestionById/" +
      countryID +
      "/" +
      questionId;
    const optionTextUrl =
      "https://api.samplicio.us/Lookup/v1/QuestionLibrary/AllQuestionOptions/" +
      countryID +
      "/" +
      questionId;

    const headers = {
      "Content-Type": "application/json",
      Authorization: "588917A2-1A5C-4D56-A823-B2E996515DE3",
    };

    try {
      const questionTextResponse = await axios.get(questionTextUrl, {
        headers,
      });
      const optionTextResponse = await axios.get(optionTextUrl, { headers });

      const allPrecodes = optionTextResponse?.data?.QuestionOptions;

      let qualificationPrecodes = questionData?.precodes;

      let commonPrecodes = [];
      let questionOptions = [];
      let isInfinite = false;
      if (allPrecodes.length !== 0) {
        commonPrecodes = allPrecodes.filter((option) =>
          Object.values(qualificationPrecodes).includes(option.Precode)
        );
        questionOptions = commonPrecodes.map((option) => option.OptionText);
        isInfinite = false;
      } else {
        questionOptions = qualificationPrecodes;
        isInfinite = true;
      }
      const questionText = questionTextResponse?.data?.Question?.Name;

      let obj = {
        completeRequired: value?.number_of_respondents,
        questionText: questionText,
        optionTexts: questionOptions || [],
      };
      return obj;
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const fetchQuestionData = async (questionId, fullData) => {
    let countryID = countryData?.Id;
    if (!countryID) {
      return;
    }
    const questionTextUrl =
      "https://api.samplicio.us/Lookup/v1/QuestionLibrary/QuestionById/" +
      countryID +
      "/" +
      questionId;
    const optionTextUrl =
      "https://api.samplicio.us/Lookup/v1/QuestionLibrary/AllQuestionOptions/" +
      countryID +
      "/" +
      questionId;

    const headers = {
      "Content-Type": "application/json",
      Authorization: "588917A2-1A5C-4D56-A823-B2E996515DE3",
    };

    try {
      const questionTextResponse = await axios.get(questionTextUrl, {
        headers,
      });
      const optionTextResponse = await axios.get(optionTextUrl, { headers });

      const allPrecodes = optionTextResponse?.data?.QuestionOptions;

      let qualificationPrecodes = fullData?.precodes;

      let commonPrecodes = [];
      let questionOptions = [];
      let isInfinite = false;
      if (allPrecodes.length !== 0) {
        commonPrecodes = allPrecodes.filter((option) =>
          Object.values(qualificationPrecodes).includes(option.Precode)
        );
        questionOptions = commonPrecodes.map((option) => option.OptionText);
        isInfinite = false;
      } else {
        questionOptions = qualificationPrecodes;
        isInfinite = true;
      }

      const questionText = questionTextResponse?.data?.Question?.QuestionText;

      return {
        questionText: questionText,
        optionTexts: questionOptions || [],
        isInfinite: isInfinite,
      };
    } catch (error) {
      console.log("error => ", error);
    }
  };

  const getData = (key) => {
    const jsonValue = sessionStorage.getItem(key);
    return jsonValue ? JSON.parse(jsonValue) : null;
  };

  if (loading) {
    return <Loader />;
  }

  const parseLocale = (locale) => {
    if (!locale || typeof locale !== "string") {
      return { language: null, country: null };
    }
  };

  const splitByDash = (text) => {
    if (!text || typeof text !== "string") return [];

    return text
      .split("-") // split by dash
      .map((part) => part.trim()); // remove extra spaces
  };

  const handleCreateSurveyLink = () => {
    const currentDate = new Date().toLocaleDateString();
    let obj = {
      projectId: details?.survey_id,
      link: links?.SupplierLink?.LiveLink,
      date: currentDate
    };
    set(ref(db, "/Surveys/" + details?.survey_id), obj).then(result => {
      let tempLink = JSON.parse(JSON.stringify(links))
      tempLink.SupplierLink.surveyLink = "http://survey.teqluc.in/?SurveyID="+details?.survey_id+"&PID="
      setLinks(tempLink)
    })
  };
  return (
    <div>
      <Tabs>
        <TabList>
          <Tab>Target</Tab>
          <Tab>Links</Tab>
          <Tab>Quota</Tab>
        </TabList>

        <TabPanel>
          <div className="tab-content">
            <div className="response-container">
              <div className="question-card">
                <h6 className="question-text">
                  {"Project ID: " +
                    surveyID +
                    " - " +
                    splitByDash(countryData?.Name)[1]}
                </h6>
              </div>
              <div className="question-card">
                <h6 className="question-text">
                  {"Langauage: " + splitByDash(countryData?.Name)[0]}
                </h6>
              </div>
              <div className="question-card">
                <h6 className="question-text">
                  {"Account Name : " + details?.account_name}
                </h6>
              </div>
              {questionData?.map((question, index) => (
                <div key={index} className="question-card">
                  <h6 className="question-text">{question?.questionText}</h6>
                  {question?.optionTexts &&
                    Object.values(question?.optionTexts).length > 0 && (
                      <div className="options-container">
                        <ul>
                          {Object.values(question?.optionTexts)?.map(
                            (option, idx) => (
                              <li key={idx} className="option-item">
                                {question?.optionTexts[idx]}
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    )}
                </div>
              ))}
            </div>
          </div>
        </TabPanel>

        <TabPanel>
          <div className="tab-content">
            <div className="response-container">
              <div className="question-card">
                <div className="links-container">
                  <h6 className="question-text">
                    {"Project ID: " +
                      surveyID +
                      " - " +
                      splitByDash(countryData?.Name)[1]}
                  </h6>
                </div>
              </div>
              <div className="question-card">
                <div className="links-container">
                  <h6 className="question-text">
                    {"Langauage: " + splitByDash(countryData?.Name)[0]}
                  </h6>
                </div>
              </div>
              <div className="question-card">
                <div className="links-container">
                  <strong>Live Link: </strong>
                  <a className="option-item">{links?.SupplierLink?.surveyLink}</a>
                  <br />
                  <strong>Test Link: </strong>
                  <a className="option-item">{links?.SupplierLink?.TestLink}</a>
                </div>
              </div>
              <div className="question-card">
                <div className="links-container">
                  <button
                    className="btn btn-danger signout-btn"
                    onClick={() => handleCreateSurveyLink()}
                  >
                    <i className="fas fa-sign-out-alt"></i> Generate Live Link
                  </button>
                </div>
              </div>
            </div>
          </div>
        </TabPanel>

        <TabPanel>
          <div className="tab-content">
            <div className="response-container">
              {QuotaQuestionData?.map((quota, index) => (
                <div key={index} className="question-card">
                  <h6 className="question-text">
                    <span className="quota-name">
                      {"Quota Title: " + quota[0]?.questionText}
                    </span>
                  </h6>

                  <div className="status">
                    <p>
                      <strong>Required Completes:</strong>{" "}
                      <span className="quota-name">
                        {quota[0]?.completeRequired ?? 0}
                      </span>
                    </p>
                  </div>

                  <div className="targeting">
                    <p>
                      <strong>Options:</strong>
                    </p>
                    {quota[0]?.optionTexts?.map((option, idx) => (
                      <div key={idx} className="age-range">
                        <ul>
                          <li className="option-item">{option}</li>
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default Detail;
